import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SharedModalService } from './../shared-modal.service';
import { Router } from '@angular/router';
import { BusinessService } from './../../pages/business/business.service';
import { AuthServiceZ } from './../../authentification/auth-service.service';

@Component({
  selector: 'app-job-request-history-partner',
  templateUrl: './job-request-history-partner.component.html',
  styleUrls: ['./job-request-history-partner.component.scss'],
})
export class JobRequestHistoryPartnerComponent implements OnChanges, OnInit {
  @Input() job;
  pickUpJobHistory = [];
  currentJobHistory = [];
  currentJobActionHistory = [];
  AllHistory = [];
  user;

  ngOnChanges() {
    // changes.prop contains the old and the new value...
    this.currentJobHistory = [];
    if (this.job?._id) {
      if (this.authService.credentials.user.userType == 'User') {
        this.getHistoryForAJob4Partner(this.job._id);
        this.getActionHistoryForAJob4Partner(this.job._id);
      } else {
        this.getHistoryForAJob(this.job._id);
        this.getActionHistoryForAJob(this.job);
      }
    }
  }

  constructor(
    public sharedModalService: SharedModalService,
    private businessService: BusinessService,
    private authService: AuthServiceZ,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.user = this.authService?.credentials?.user?.userType;
  }

  getHistoryForAJob(jobId) {
    var query = {
      jobRequest: jobId,
    };
    var populate = [
      {
        path: 'jobRequest',
        populate: [
          { path: 'createdBy', select: 'name' },
          { path: 'pointRelais' },
          { path: 'centrale', select: 'name' },
          { path: 'dropOff' },
        ],
      },
      { path: 'driver', select: 'name' },
      { path: 'oldDriver', select: 'name' },
      { path: 'newDriver', select: 'name' },
      { path: 'centrale', select: 'name' },
      { path: 'destinationCentral', select: 'name' },
      { path: 'actionDoneBy', select: 'name' },
    ];

    console.log(jobId);
    console.log(query);

    this.sharedModalService.getJobRequestHistory(query, populate).then((d) => {
      this.currentJobHistory = d.body;
      if (this.job.pickUpJob) {
        var populate = [
          {
            path: 'jobRequest',
            populate: [
              { path: 'createdBy', select: 'name' },
              { path: 'pointRelais' },
              { path: 'dropOff' },
              { path: 'centrale', select: 'name' },
            ],
          },
          { path: 'centrale', select: 'name' },
          { path: 'destinationCentral', select: 'name' },

          { path: 'driver', select: 'name' },
          { path: 'oldDriver', select: 'name' },
          { path: 'newDriver', select: 'name' },
          { path: 'actionDoneBy', select: 'name' },
        ];
        let query2 = {
          jobRequest: this.job.pickUpJob._id
            ? this.job.pickUpJob._id
            : this.job.pickUpJob,
        };
        console.log('query2', query2);

        this.sharedModalService
          .getJobRequestHistory(query2, populate)
          .then((d) => {
            for (let index = 0; index < d.body.length; index++) {
              this.currentJobHistory.unshift(d.body[d.body.length - 1 - index]);
            }
            this.currentJobHistory.sort((a, b) => {
              return new Date(a.date) > new Date(b.date) ? 1 : -1;
            });
          });
      }
    });
  }

  getActionHistoryForAJob(jobId) {
    var query = {
      nid: jobId.nid,
      jobRequest: jobId._id,
    };
    var populate = [
      { path: 'jobRequest' },
      { path: 'centrale' },
      { path: 'business' },
      { path: 'driver', select: 'name' },
      { path: 'admin', select: 'name' },
    ];
    this.sharedModalService
      .getJobRequestActionHistory(query, populate)
      .then((d) => {
        this.currentJobActionHistory = d;
      })
      .then((d) => {
        if (this.job.pickUpJob) {
          var populate = [
            { path: 'jobRequest' },
            { path: 'business' },
            { path: 'centrale' },
            { path: 'driver', select: 'name' },
            { path: 'admin', select: 'name' },
          ];
          var query = {
            jobRequest: this.job.pickUpJob._id
              ? this.job.pickUpJob._id
              : this.job.pickUpJob,
          };
          this.sharedModalService
            .getJobRequestActionHistory(query, populate)
            .then((d) => {
              for (let index = 0; index < d.length; index++) {
                this.currentJobActionHistory.unshift(d[d.length - 1 - index]);
              }
            });
        }
      });
  }

  getHistoryForAJob4Partner(jobId) {
    var query = {
      jobRequest: jobId,
    };
    var populate = [
      {
        path: 'jobRequest',
        populate: [
          { path: 'createdBy', select: 'name' },
          { path: 'pointRelais' },
          { path: 'centrale', select: 'name' },
          { path: 'dropOff' },
        ],
      },
      { path: 'driver', select: 'name' },
      { path: 'oldDriver', select: 'name' },
      { path: 'newDriver', select: 'name' },
      { path: 'centrale', select: 'name' },
      { path: 'destinationCentral', select: 'name' },
      { path: 'actionDoneBy', select: 'name' },
    ];

    console.log(jobId);
    console.log(query);

    this.businessService.getJobRequestHistory(query, populate).then((d) => {
      this.currentJobHistory = d.body;
      if (this.job.pickUpJob) {
        var populate = [
          {
            path: 'jobRequest',
            populate: [
              { path: 'createdBy', select: 'name' },
              { path: 'pointRelais' },
              { path: 'dropOff' },
              { path: 'centrale', select: 'name' },
            ],
          },
          { path: 'centrale', select: 'name' },
          { path: 'destinationCentral', select: 'name' },

          { path: 'driver', select: 'name' },
          { path: 'oldDriver', select: 'name' },
          { path: 'newDriver', select: 'name' },
          { path: 'actionDoneBy', select: 'name' },
        ];
        let query2 = {
          jobRequest: this.job.pickUpJob._id
            ? this.job.pickUpJob._id
            : this.job.pickUpJob,
        };
        console.log('query2', query2);

        this.businessService
          .getJobRequestHistory(query2, populate)
          .then((d) => {
            for (let index = 0; index < d.body.length; index++) {
              this.currentJobHistory.unshift(d.body[d.body.length - 1 - index]);
            }
            this.currentJobHistory.sort((a, b) => {
              return new Date(a.date) > new Date(b.date) ? 1 : -1;
            });

            console.log('this.currentJobActionHistory');
            console.log(this.currentJobActionHistory);
            console.log(this.currentJobHistory);

            const hisData = this.currentJobHistory.concat(
              this.currentJobActionHistory
            );

            this.AllHistory = hisData.sort((a, b) => {
              if (a.createdAt && b.createdAt) {
                console.log('createdAt createdAt');
                return new Date(a.createdAt) < new Date(a.createdAt) ? -1 : 1;
              } else if (a.createdAt && !b.createdAt) {
                console.log('createdAt date');
                return new Date(a.createdAt) < new Date(b.date) ? -1 : 1;
              } else if (!a.createdAt && b.createdAt) {
                console.log('date createdAt');
                return new Date(a.date) < new Date(a.createdAt) ? -1 : 1;
              } else if (a.date && b.date) {
                console.log('date date');
                return new Date(a.date) < new Date(b.date) ? -1 : 1;
              } else {
                return 1;
              }
            });
            console.log(this.AllHistory);
          });
      }
    });
  }

  getActionHistoryForAJob4Partner(jobId) {
    var query = {
      jobRequest: jobId,
    };
    var populate = [
      { path: 'jobRequest' },
      { path: 'centrale' },
      { path: 'business' },
      { path: 'driver', select: 'name' },
      { path: 'admin', select: 'name' },
    ];
    this.businessService
      .getJobRequestActionHistory(query, populate)
      .then((d) => {
        this.currentJobActionHistory = d;
      })
      .then((d) => {
        if (this.job.pickUpJob) {
          var populate = [
            { path: 'jobRequest' },
            { path: 'business' },
            { path: 'centrale' },
            { path: 'driver', select: 'name' },
            { path: 'admin', select: 'name' },
          ];
          var query = {
            jobRequest: this.job.pickUpJob._id
              ? this.job.pickUpJob._id
              : this.job.pickUpJob,
          };
          this.businessService
            .getJobRequestActionHistory(query, populate)
            .then((d) => {
              for (let index = 0; index < d.length; index++) {
                this.currentJobActionHistory.unshift(d[d.length - 1 - index]);
              }
            });
        }
      });
  }
}
